module.exports = __webpack_public_path__ + "static/media/094-bhutan.e3280f71.svg";